module.exports = __webpack_public_path__ + "static/media/forcesActingOnParticle1.6ded41ea.svg";